import {
  useRouter 
} from "next/navigation"
import {
  useCallback 
} from "react"
import SimpleImage from "../Image/simpleImage"
import classes from "./ad.module.css"

const IMAGE_WIDTH = 280
const IMAGE_HEIGHT = 410

const GalleryAd = (props) => {
  const {
    item 
  } = props

  const router = useRouter()

  const onClick = useCallback(() => {
    try {
      if (item.link.indexOf("http") > -1) {
        window.open(item.link, "_self");
      } else {
        const path = item.link.startsWith("/") ? item.link : `/${item.link}`;

        router.push(path);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      // 这里可以添加适当的错误处理逻辑
    }
  }, [item.link, router]);


  return (
    <div>
      <div className={classes.imageContainer} onClick={onClick}>
        <SimpleImage
          alt={"ad"}
          width={IMAGE_WIDTH}
          height={IMAGE_HEIGHT}
          src={item.img}
        />
      </div>
    </div>
  )
}

export default GalleryAd
